<template>
  <div class="bg-surface-container rounded-large px-4 pt-4 pb-1">
    <h4 class="text-title-medium mb-3">{{ question.content }}</h4>
    <div
      v-if="scale.type === ScaleType.ImageButtons"
      class="relative flex w-full flex-col gap-0.5 md:flex-row"
    >
      <button
        v-for="(scaleItem, index) in scale.items"
        @click="updateValue(scaleItem.value)"
        class="group ease-fast-spatial relative flex min-w-0 cursor-pointer flex-col overflow-hidden p-2 text-left transition-all md:grow md:basis-1"
        :class="[
          feedbackValue == scaleItem.value && 'bg-primary-container rounded-large',
          feedbackValue != scaleItem.value &&
            'bg-surface first:rounded-l-medium rounded-extra-small last:rounded-r-medium',
        ]"
      >
        <div
          class="rounded-extra-small mr-auto flex h-5 shrink-0 flex-row items-center justify-between gap-1 px-2"
          :class="[
            feedbackValue != scaleItem.value && 'bg-surface-container-high',
            feedbackValue == scaleItem.value && 'bg-primary text-on-primary',
          ]"
        >
          <img
            :src="scaleItem.image"
            class="h-8"
            :class="[feedbackValue == scaleItem.value && 'invert-100']"
          />
          <span class="text-label-small">{{ scaleItem.label }}</span>
        </div>
        <div class="mt-1 p-1.5">
          <span class="text-body-medium" v-html="question.scaleItemDescriptions?.[index]"></span>
        </div>
        <BaseStateLayer />
      </button>
    </div>
    <div class="mt-1 flex flex-row justify-center">
      <span class="text-label-small text-outline">Beispielindikatoren</span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import { ScaleType, type Scale } from '@/core/models/scale'

  defineProps<{
    question: {
      readonly id: string
      readonly content: string
      readonly scaleItemDescriptions?: ReadonlyArray<string>
    }
    scale: Scale
  }>()
  const feedbackValue = defineModel<number | null>({ required: true })

  const updateValue = (value: number) => {
    feedbackValue.value = feedbackValue.value === value ? null : value
  }
</script>
